import React from "react";
import "../styles/recentwork.css";
const RecentWork = () => {
  const imageList = [
    {
      id: 1,
      src: "https://th.bing.com/th/id/OIP.HIfnzX8-WEvO3heRe7UAmAHaEK?pid=ImgDet&rs=1",
      alt: "movie",
      title: "Movies21",
      description: "Web application to search for current movies.",
      link: "https://movies21.vercel.app/",
      git: "https://github.com/lutfianwr/movies-app-react",
      tech: ["ReactJs", "Tailwind", "Axios"],
    },
    {
      id: 2,
      src: "https://raw.githubusercontent.com/lutfianwr/todolist/main/src/assets/todolist.png",
      alt: "todo list",
      title: "My Todo List",
      description:
        "Web application that allows users to create, edit, and delete their to do list.",
      link: "https://todolist-blue.netlify.app/",
      git: "https://github.com/lutfianwr/todolist",
      tech: ["ReactJs", "Tailwind", "Axios"],
    },
    {
      id: 5,
      src: "https://th.bing.com/th/id/OIP.IJTIRqKRifpzJW_QlRYuWQHaGm?pid=ImgDet&rs=1",
      alt: "bookshelf",
      title: "Bookshelf Apps",
      description:
        "Bookshelf app using basic Document Object Model manipulation.",
      link: "https://bookshelf-lutfian.vercel.app/",
      git: "https://github.com/lutfianwr/bookshelf",
      tech: ["HTML", "CSS", "DOM"],
    },
    {
      id: 6,
      src: "https://i2.wp.com/thespoon.tech/wp-content/uploads/2017/03/Screen-Shot-2017-03-19-at-5.53.28-AM.png?fit=1650%2C934&ssl=1",
      alt: "wisfood",
      title: "WisataFoodie",
      description: "Restaurant finder and booking web application.",
      link: "https://wisata-foodie.vercel.app/",
      git: "https://github.com/lutfianwr/wisata-foodie",
      tech: ["ReactJs", "Axios", "React Leaflet"],
    },
    {
      id: 7,
      src: "https://angularexpo.com/content/images/2017/01/angular-2-pokedex.png",
      alt: "pokeroom",
      title: "Poké Room",
      description: "Pokemon catcher application using graph api, catch em all.",
      git: "https://github.com/lutfianwr/poke-catcher",
      link: "https://poke-room.netlify.app/",
      tech: ["NextJs", "SCSS", "graph api"],
    },
    {
      id: 8,
      src: "https://fossbytes.com/wp-content/uploads/2019/11/The-Best-Android-News-Apps-For-You.jpg",
      alt: "Mak news",
      title: "Mak news",
      description: "Mobile News application using newsapi and next js",
      git: "https://github.com/lutfianwr/news-app",
      link: "https://maknews.vercel.app/",
      tech: ["NextJs", "MUI", "newsapi"],
    },
  ];

  return (
    <div className="section py-4" id="recent-work">
      <div className="container" id="recent-work">
        <h1 id="title">
          My recent <span>works</span>
        </h1>
        <div className="row">
          {imageList.map((image) => (
            <div key={image.id} className="col-md-4 mt-4">
              <div className="cards p-3 bg-opacity-10">
                <a href={image.link} target="blank">
                  <img
                    className="card-img-top"
                    src={image.src}
                    alt={image.alt}
                    id="project-img"
                  />
                </a>
                <div className="card-body">
                  <div className="card-title mt-3 mb-2 d-flex justify-content-between">
                    <p>{image.title}</p>
                    <div>
                      <a href={image.git} target="blank">
                        <i className="bi bi-github m-2"></i>
                      </a>
                      <a href={image.link} target="blank">
                        <i className="bi bi-box-arrow-up-right"></i>
                      </a>
                    </div>
                  </div>
                  <p className="card-text mb-auto opacity-75">
                    {image.description}
                  </p>

                  <div className="d-flex flex-wrap justify-content-center">
                    {image.tech.map((item, index) => (
                      <div className="tech me-2 bg-opacity-50" key={index}>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RecentWork;
